export enum TiptapMode {
  ALL = 'all',
  EXECUTION_MODE = 'executionMode',
  CONFIGURATION_MODE = 'configurationMode',
  READ_ONLY = 'readOnly',
}
